import { render, staticRenderFns } from "./AddCriteria.vue?vue&type=template&id=8c37d430&scoped=true"
import script from "./AddCriteria.vue?vue&type=script&lang=js"
export * from "./AddCriteria.vue?vue&type=script&lang=js"
import style0 from "./AddCriteria.vue?vue&type=style&index=0&id=8c37d430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c37d430",
  null
  
)

export default component.exports